"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Upgrade/UpgradeModal/SuccessModal.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _routes = require('web/chat/routes'); var _routes2 = _interopRequireDefault(_routes);
var _upgrade = require('shared/enum/upgrade');
var _org = require('shared/selectors/org');
var _useOrgAccount = require('shared/hooks/useOrgAccount');

var _components = require('./components');
var _Form = require('web/components/Form');
var _reactrouterdom = require('react-router-dom');
var _onboardingAnalytics = require('web/services/onboardingAnalytics');



var _freeCapAnalytics = require('web/services/freeCapAnalytics');
var _hooks = require('web/services/hooks');










const itemDisplayNames = {
  [_upgrade.SubscriptionItemType.TEAM]: 'Base Messaging',
  [_upgrade.SubscriptionItemType.SMS]: 'SMS Messaging',
  [_upgrade.SubscriptionItemType.VIDEO]: 'Video & Telehealth',
  [_upgrade.SubscriptionItemType.PHONE_NUMBER]: 'Additional SMS Numbers',
}

const SuccessModal = ({
  isOpen,
  onClose,
  orgKey,
  planTypes,
  actionType,
  source,
}) => {
  const orgName = _hooks.useAppSelector.call(void 0, state => _nullishCoalesce(_optionalChain([_org.selectOrgByKey.call(void 0, orgKey, state), 'optionalAccess', _ => _.Name]), () => ( 'Your org')))
  const activeMemberCount = _hooks.useAppSelector.call(void 0, state => {
    const org = _org.selectOrgByKey.call(void 0, orgKey, state)
    return org && 'NumberOfMembers' in org
      ? org.NumberOfMembers
      : undefined
  })
  const hasTrackedConversion = _react.useRef.call(void 0, false)
  const hasTrackedFreeCapSuccess = _react.useRef.call(void 0, false)
  // In a flagged account the plan lives on Account → Plan (D-67), for its
  // Owners and IT; others there have no plan page.
  const account = _useOrgAccount.useOrgAccount.call(void 0, isOpen ? orgKey : null)
  const isFlagged = !!_optionalChain([account, 'optionalAccess', _2 => _2.Flagged])
  const planSettingsURL = _useOrgAccount.isManagedAccount.call(void 0, account)
    ? _routes.makeRoute.call(void 0, _routes2.default.SETTINGS.ACCOUNT_PAGE, { orgKey: account.DefaultOrgKey, tabName: 'plan' })
    : isFlagged ? null : _routes.makeRoute.call(void 0, _routes2.default.SETTINGS.ORG_PAGE, { tabName: 'plan', orgKey })

  _react.useEffect.call(void 0, () => {
    if (
      !isOpen
        || hasTrackedConversion.current
        || actionType !== _upgrade.CheckoutActionType.UPGRADE
    ) return

    hasTrackedConversion.current = true
    _onboardingAnalytics.captureSubscriptionConvertedToPaid.call(void 0, {
      organization_id: orgKey,
      plan_type: planTypes.join(','),
      action_type: actionType,
    })
  }, [actionType, isOpen, orgKey, planTypes])

  _react.useEffect.call(void 0, 
    () => {
      if (
        !isOpen
          || hasTrackedFreeCapSuccess.current
          || source !== _freeCapAnalytics.FREE_CAP_ANALYTICS_SOURCE
          || !planTypes.includes(_upgrade.SubscriptionItemType.TEAM)
          || actionType !== _upgrade.CheckoutActionType.UPGRADE
      ) return

      _freeCapAnalytics.trackFreeCapLockedChatUpgradeSucceeded.call(void 0, 
        { source, orgKey, activeMemberCount },
        planTypes,
        actionType,
      )
      hasTrackedFreeCapSuccess.current = true
    },
    [activeMemberCount, actionType, isOpen, orgKey, planTypes, source],
  )

  const planDisplayName = planTypes.map(planType => itemDisplayNames[planType]).join(' and ')

  const renderMsg = () => {
    if (actionType === _upgrade.CheckoutActionType.UPGRADE) {
      return _react2.default.createElement(_react2.default.Fragment, null,  orgName , " has been upgraded to "     ,  planDisplayName )
    }
    if (actionType === _upgrade.CheckoutActionType.CHANGE_TIER) {
      return _react2.default.createElement(_react2.default.Fragment, null, "Your " , planDisplayName, " tier has been updated"    )
    }
    return null
  }

  return (
    _react2.default.createElement(_components.PlanModal, {
      isOpen: isOpen,
      onClose: onClose,
      className: "plan-modal--success", __self: this, __source: {fileName: _jsxFileName, lineNumber: 108}}

      , _react2.default.createElement('div', { className: "plan-modal--success--icon", __self: this, __source: {fileName: _jsxFileName, lineNumber: 113}} )
      , _react2.default.createElement('h1', { className: "plan-modal--success--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 114}}
        ,  renderMsg() 
      )
      ,  planSettingsURL && (
        _react2.default.createElement('span', { className: "plan-modal--success--desc", __self: this, __source: {fileName: _jsxFileName, lineNumber: 118}}, "You can manage your plan in your "
                 , ' '
          , _react2.default.createElement(_reactrouterdom.Link, { to: planSettingsURL, onClick: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 120}}, "settings"), "."
        )
      )
      , _react2.default.createElement(_Form.Button, { onClick: onClose, className: "plan-modal--success--btn", __self: this, __source: {fileName: _jsxFileName, lineNumber: 123}}, "OK"

      )
    )
  )
}

exports. default = _react.memo.call(void 0, SuccessModal)
